import React, { useEffect } from 'react';
import { Spinner, Col, Row } from 'react-bootstrap';

import useGlobal from '../../../../store';
import Loading from '../../../../facturotopia/loading/Loading';
import PageHeader from '../../../../support/page-header/PageHeader';
import GenericSimpleRenderItems from '../../../../app/comprobantes/create/complementos/summary/GenericSimpleRenderItems';

const mapState = (store) => {
  return store.modulo.retenciones_masivas.tickets.info;
};

const mapActions = (actions) => {
  return actions.modulo.retenciones_masivas.tickets.info;
};

const RetencionesMasivasTicketsInfo = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);

  const { id } = props.match.params;
  const { data: info } = props.location?.state || {};

  useEffect(() => {
    if (!!info) {
      actions.reset();
      actions.setInfo(info);
    } else {
      actions.info(id);
    }
  }, []); //eslint-disable-line

  const { data, busy } = state;

  if (!!busy) {
    return <Loading className="text-info" />;
  }

  return (
    <>
      <PageHeader
        to="/modulos/retenciones-masivas/tickets"
        text="Retenciones Masivas"
      />

      <h5>
        <Row>
          <Col>
            {busy && (
              <Spinner
                animation="border"
                role="status"
                size="sm"
                className="mr-3"
              >
                <span className="sr-only">Loading ticket info...</span>
              </Spinner>
            )}
            {data.id || '...'}
          </Col>
        </Row>
      </h5>

      {!!data.id && (
        <div>
          <div className="d-block mt-3 mb-2">
            <strong className="text-muted">Detalles</strong>
            <br />
            <GenericSimpleRenderItems
              data={data}
              labels={labels}
            />
          </div>

          <div className="d-block mt-3 mb-2">
            <strong className="text-muted">Errores</strong>
            <br />
            <strong className="text-muted">{data.razon_status}</strong>
          </div>
        </div>
      )}
    </>
  );
};

const labels = [
  {
    label: 'Fecha Servicio',
    index: 'fecha_servicio',
  },
  {
    label: 'Folio fiscal',
    index: 'cfdi_uuid',
  },
  {
    label: 'Clave retención',
    index: 'cve_retenc',
  },
  {
    label: 'Descripción',
    index: 'desc_retenc',
  },
  {
    label: 'Mes inicio',
    index: 'mes_ini',
  },
  {
    label: 'Mes Final',
    index: 'mes_fin',
  },
  {
    label: 'Ejercicio',
    index: 'ejercicio',
  },
];

export default RetencionesMasivasTicketsInfo;
